module.exports = __webpack_public_path__ + "img/helper.d789d7ed.svg";